import { PremiumDetailsField } from '@/App/Blotter/grids/accumulator/details/PremiumDetailsField.tsx';
import { BlotterDetailsField } from '@/App/Blotter/grids/details/BlotterDetailsField.tsx';
import { useUserContext } from '@/context/UserContext.tsx';
import type { BlotterAccumulatorEntry } from '@/store/blotter/types/BlotterAccumulatorEntry.ts';

type Props = {
  entry: BlotterAccumulatorEntry;
};

export const Fieldset = ({ entry }: Props) => {
  const {
    currentUser: { userType },
  } = useUserContext();

  const isInternalSales = userType === 'Internal Sales';

  return (
    <div className="container-fluid">
      <div className="row">
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Accumulator.details.way"
          labelI18NValues={{ isInternalSales }}
          value={`${entry.way} ${entry.currencyPair}`}
        />
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Accumulator.details.dealtAmount"
          formatting="amount"
          valueDataE2e="DealtAmount-field"
          value={entry.dealtAmount}
          currency={entry.dealtCurrency}
        />
      </div>
      <div className="row">
        <PremiumDetailsField entry={entry} />
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Accumulator.details.account"
          value={entry.account}
          minWidth="30ch"
        />
      </div>
      <div className="row">
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Accumulator.details.expiry"
          formatting="date"
          value={entry.expiry}
        />
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Accumulator.details.execTime"
          formatting="date"
          value={entry.execTime}
        />
      </div>
    </div>
  );
};
